import { Box, useBreakpointDown } from '@chronosphereio/chrono-ui';

/**
 * Vertical rule between groups of `QueryEditor.ToolbarActionItem` items — typically
 * **query-adjacent** actions vs **navigation** links. Hidden on narrow
 * viewports where the actions collapse into an overflow menu.
 */
export function QueryEditorToolbarDivider() {
  const isNarrow = useBreakpointDown('md', { breakpointSource: 'viewport' });
  if (isNarrow) return null;

  return (
    <Box
      aria-hidden
      sx={{
        alignSelf: 'stretch',
        width: 0,
        borderLeft: '1px solid',
        borderColor: 'divider',
        mx: 1,
      }}
    />
  );
}
